module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-segment-js/gatsby-browser.js'),
      options: {"plugins":[],"prodKey":"1viYmCaBdgeqFXZJMpRM7rNnSaBt1Rnk","devKey":"hoHnbaHDokDjEsHhpKalLelFsJTOUxHR","trackPage":true},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
